var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FC686F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7416 40V30.8777H34.8023L35.2615 27.3216H31.7416V25.0515C31.7416 24.0222 32.0262 23.3208 33.5039 23.3208L35.3854 23.32V20.1392C35.06 20.0969 33.9431 20 32.6431 20C29.9285 20 28.07 21.657 28.07 24.6993V27.3216H25V30.8777H28.07V40H31.7416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFacebookIcon);
export default __webpack_public_path__ + "static/media/share-facebook-icon.0661cb8ac62eb4cd4153abb2ea40f847.svg";
export { ForwardRef as ReactComponent };